import { Box } from "@mui/material";
import React from "react";

import Sidebar from "../components/Layout/Sidebar";
import ValueChainView from "../components/ValueChain/ValueChainView";

const ValueChainPage: React.FC = () => (
  <Box
    sx={{
      display: "flex",
      height: "100vh",
      backgroundColor: "background.default",
      overflow: "hidden",
    }}
  >
    <Sidebar />
    {/* Positioned, so that the detail overlay can lie over this part */}
    <Box sx={{ flex: 1, minWidth: 0, height: "100%", position: "relative" }}>
      <ValueChainView />
    </Box>
  </Box>
);

export default ValueChainPage;
